import React from 'react'

import {
  AlignItems,
  Body2,
  Box,
  Display,
  Heading1,
  JustifyContent,
  Space,
  TextAlign,
} from '@gousto-internal/citrus-react'

import { ContentstackImage } from '../ContentstackImage'
import type { HeroFields } from './types'

import { CtaLink, mapCmsCta } from '../../cta'
import type { CmsCtaIntentHandlers } from '../../cta'

export type HeroProps = HeroFields & {
  ctaIntentHandlers?: CmsCtaIntentHandlers
}

function getBodyParagraphs(body?: string) {
  if (!body) {
    return []
  }

  return body
    .split(/\n\s*\n/)
    .map((paragraph) => paragraph.trim())
    .filter(Boolean)
}

export function Hero({
  heading,
  body,
  cta,
  ctaIntentHandlers,
  image,
  image_alt,
  image_mobile,
}: HeroProps) {
  const bodyParagraphs = getBodyParagraphs(body)
  const ctaLink = mapCmsCta(cta, ctaIntentHandlers)

  return (
    <Box>
      <Box
        display={Display.Flex}
        alignItems={AlignItems.Center}
        justifyContent={JustifyContent.Center}
        paddingH={[4, 8, 20]}
        paddingV={[8, 16]}
        paddingBottom={[12, 16]}
      >
        <Box maxWidth="512px">
          <Box paddingBottom={3}>
            <Heading1 textAlign={TextAlign.Center}>{heading}</Heading1>
          </Box>

          {bodyParagraphs.length > 0 && (
            <Box paddingBottom={[4]} paddingRight={[null, 4]}>
              {bodyParagraphs.map((paragraph, index) => (
                <React.Fragment key={paragraph}>
                  {index > 0 && <Space size={4} />}
                  <Body2 size={4} textAlign={TextAlign.Center}>
                    {paragraph}
                  </Body2>
                </React.Fragment>
              ))}
            </Box>
          )}

          {ctaLink && (
            <Box display={Display.Flex} justifyContent={JustifyContent.Center}>
              <CtaLink cta={ctaLink} />
            </Box>
          )}
        </Box>
      </Box>

      {image?.url && (
        <ContentstackImage
          fit="cover"
          width="100%"
          height={['120px', '141px', null, '160px']}
          sizes="100vw"
          alt={image_alt || ''}
          src={image.url}
          mobileSrc={image_mobile?.url}
        />
      )}
    </Box>
  )
}
